<template>
  <div class="input-group-append" v-bind="$attrs" v-on="$listeners">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseInputGroupAppend",
  inheritAttrs: false,
};
</script>
